export const SlideHeader = ({ header, helper = '' }) => {
  return (
    <div className='d-flex flex-column text-center my-4'>
      <h1 className='text-center' style={{ fontSize: '1.8rem' }}>
        {header}
      </h1>
      {helper ? <small>{helper}</small> : null}
    </div>
  )
}
